/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutItemWrapSX } from '@/components/layouts/styles/itemWrap';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const IntertoysActiesAndFolderLayout1_rv: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		customDimensions: { layoutSpacing },
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
				<Stack
                    id="main-content"
					component="main"
					gap={layoutSpacing}
					sx={layoutMainSX(layout.slots.first?.length || 0)}
				>
					<Container component="section">
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}>
                                <LayoutSlot slot={layout.slots.first} />
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.second} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.third} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourth} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifth} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.six} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seven} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eight} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nine} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ten} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eleven} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twelve} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirteen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourteen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifteen} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixteen} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventeen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eighteen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nineteen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twenty} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyone} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentytwo} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentythree} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfour} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfive} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentysix} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyseven} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyeight} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentynine} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirty} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyone} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtytwo} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtythree} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyfour} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyfive} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtysix} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyseven} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyeight} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtynine} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.forty} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyone} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortytwo} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortythree} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyfour} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyfive} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortysix} /></Grid>
                        </Grid>
						
					</Container>
	    	</Stack>
            <LayoutSlot slot={layout.slots.footer} />
		</>
	) : null;
};